(function () {
// Theme entry point.
// Custom scripts are jQuery-based IIFEs that run on import and rely on
// globals (jQuery, gsap, ScrollTrigger, ajaxurl) enqueued separately in PHP.
var $c0445db728cdb526$exports = {};
(function($, root, undefined) {
    $(function() {
        "use strict";
        // DOM ready, take it away
        gsap.registerPlugin("ScrollTrigger");
        gsap.registerPlugin("CSSPlugin");
        gsap.config({
            nullTargetWarn: false
        });
        // parallax
        function createParallax() {
            gsap.to(".parallax-item", {
                scrollTrigger: {
                    scrub: true,
                    invalidateOnRefresh: true
                },
                y: (i, target)=>-ScrollTrigger.maxScroll(window) * target.dataset.speed,
                ease: "none"
            });
        }
        createParallax();
        // logo animation
        const logoAnimation = gsap.timeline({
            paused: true
        });
        const logo = $("#logo");
        const logoTwo = $(logo).find(".two");
        const logoFrom = $(logo).find(".from");
        const logoLargeTwo = $(logo).find(".logo-two");
        const animationSpeed = 0.6;
        const animationSpeedBack = 0.3;
        let playing = false;
        // set flag
        logoAnimation.add(function() {
            playing = true;
        });
        // animate them away
        logoAnimation.to(logoTwo, {
            // delay:animationSpeed*2,
            duration: animationSpeed,
            x: "120px",
            ease: Power4.easeOut,
            opacity: 0
        });
        logoAnimation.to(logoFrom, {
            duration: animationSpeed,
            delay: -animationSpeed,
            x: "-120px",
            ease: Power4.easeOut,
            opacity: 0
        });
        // set a random order for both
        logoAnimation.add(function() {
            var randomValue = Math.round(Math.random());
            if (randomValue == 0) logoFrom.detach().insertBefore(logoLargeTwo);
            else logoFrom.detach().insertAfter(logoLargeTwo);
        });
        logoAnimation.add(function() {
            var randomValue = Math.round(Math.random());
            if (randomValue == 0) logoTwo.detach().insertBefore(logoLargeTwo);
            else logoTwo.detach().insertAfter(logoLargeTwo);
        });
        // animate them back
        logoAnimation.to(logoTwo, {
            duration: animationSpeedBack,
            x: "0",
            ease: Power4.easeOut,
            opacity: 1
        });
        logoAnimation.to(logoFrom, {
            duration: animationSpeedBack,
            delay: -animationSpeedBack,
            x: "0",
            ease: Power4.easeOut,
            opacity: 1
        });
        // reset the flag and timeline back to start
        logoAnimation.add(function() {
            playing = false;
        });
        // play the animation
        setTimeout(function() {
            logoAnimation.play();
        }, 2000);
        // on logo hover play again
        logo.on("mouseenter", function() {
            if (playing == false) {
                logoAnimation.restart();
                logoAnimation.play();
            }
        });
        // menu constants
        const openMenu = gsap.timeline({
            paused: true
        });
        const openMenuButton = $("#open-menu");
        // open menu timeline animations
        openMenu.from("#nav", {
            duration: 0.6,
            ease: Power4.easeOut,
            y: "-100%"
        });
        openMenu.to("#nav", {
            duration: 0.6,
            delay: -0.6,
            ease: Power4.easeOut,
            autoAlpha: 1
        });
        // open menu timeline animations
        openMenu.from("#nav li", {
            delay: -0.4,
            duration: 0.4,
            stagger: 0.02,
            ease: Power4.easeOut,
            y: "-50%",
            autoAlpha: 0
        });
        // open menu timeline animations
        openMenu.to(".contact-details", {
            delay: -0.4,
            duration: 0.6,
            ease: Power4.easeOut,
            autoAlpha: 1
        });
        // open menu
        function openMenuActions() {
            openMenu.play().timeScale(1);
            // check if url is .com
            if (window.location.href.indexOf(".com") > -1) openMenuButton.html("back");
            else openMenuButton.html("terug");
            $(".wrapper").addClass("blurred");
            $("html").addClass("no-scroll");
        }
        // close menu
        function closeMenuActions() {
            openMenu.reverse().timeScale(-2);
            openMenuButton.removeClass("active").html("menu");
            $(".wrapper").removeClass("blurred");
            $("html").removeClass("no-scroll");
        }
        // open menu event handler
        openMenuButton.on("click", function() {
            // toggle classes
            $(this).toggleClass("active");
            if ($(this).hasClass("active")) openMenuActions();
            else closeMenuActions();
        });
        // add class to inout container
        function makeInputContainerWhite(field) {
            let parentDiv = $(field).closest(".ginput_container");
            if ($(field).val() !== "") $(parentDiv).addClass("active");
            else $(parentDiv).removeClass("active");
        }
        // on changes -> add class to ginput_container
        $(":input").on("keyup change", function() {
            let field = $(this);
            makeInputContainerWhite(field);
        });
        $("select").change(function() {
            let parentDiv = $(this).closest(".ginput_container_select");
            if ($(this).val() !== "") $(parentDiv).addClass("active");
            else $(parentDiv).removeClass("active");
        });
        // performances filter
        // $('#performances-filter .ginput_container_select .close').click(function() {
        // 	let parentDiv = $(this).closest('.ginput_container_select');
        // 	let selectField = $(parentDiv).find('select');
        //
        // 	$(selectField).prop('selectedIndex',0); // back to default
        // 	$(selectField).find('option:selected').removeAttr('selected'); // remove selected option
        //
        // 	$(parentDiv).removeClass('active'); // remove active class from container
        // 	$('#performances-filter').trigger('change'); // trigger ajax call and update results
        // });
        // sliders
        $("#slider").flickity({
            cellAlign: "left",
            contain: false,
            freeScroll: false,
            prevNextButtons: false,
            pageDots: false,
            wrapAround: true,
            autoPlay: 4000
        });
        // Masonry grid
        function packeryGrid() {
            let $grid = $(".grid");
            $grid.imagesLoaded().progress(function() {
                $grid.packery();
            });
            $(window).trigger("resize");
        }
        if ($(".grid").length) packeryGrid();
        // press photo modal
        const modal = $("#modal");
        const modalContent = $("#modal-content");
        let pressFotos = $(".pressfotos figure");
        // close modal function
        function modal_close() {
            $("body").find(modal).fadeOut();
            $("html").removeClass("noscroll");
        }
        // close modal
        modal.click(function() {
            //if you click on anything except the modal itself or the "open modal" link, close the modal
            if (!$(event.target).closest(modalContent).length) modal_close();
        });
        // create modal content
        function create_modal_content(figure) {
            let largeImage = $(figure).data("imageLarge");
            let originalImage = $(figure).data("imageOriginal");
            let title = $(figure).data("imageTitle");
            let totalImages = pressFotos.length;
            let imageNumber = $(figure).data("imageNumber");
            let prevImage = "";
            let nextImage = "";
            if (imageNumber == 1) prevImage = totalImages;
            else prevImage = imageNumber - 1;
            if (imageNumber == totalImages) nextImage = 1;
            else nextImage = imageNumber + 1;
            let html = "";
            let image = '<img src="' + largeImage + '">';
            let modalTitle = '<div class="title">' + title + ' <a download="' + title + '" href="' + originalImage + '" title="' + title + '">download</div>';
            let prev = '<div data-goto-image="' + prevImage + '" class="arrow prev"></div>';
            let next = '<div data-goto-image="' + nextImage + '" class="arrow next"></div>';
            html += image;
            html += modalTitle;
            html += prev;
            html += next;
            modalContent.html(html);
            modalContent.find("img").hide().fadeIn();
        }
        // open modal and add image content
        pressFotos.click(function() {
            let figure = $(this);
            modalContent.html();
            create_modal_content(figure);
            modal.fadeIn().css("display", "flex");
        });
        // prev/next modal
        $(document).on("click", ".arrow", function() {
            let imageId = $(this).data("gotoImage");
            let figure = $("#image-" + imageId);
            create_modal_content(figure);
        });
        // datepicker
        // $("#datepicker").datepicker({
        //     dateFormat: "dd-mm-yy"
        // });
        // scroll to playlist on landingspage
        $(".scroll-to-playlist").click(function() {
            $("html, body").animate({
                scrollTop: $(".playlist-block").offset().top - 48
            }, 1000);
        });
        const socialMediaKit = $("#modal-social-media-kit");
        const socialMediaKitContent = $("#social-media-kit-content");
        const socialMediaKitClose = $("#modal-social-media-kit-close");
        $("#open-social-media-kit").click(function() {
            socialMediaKit.fadeIn();
        });
        socialMediaKitClose.click(function() {
            socialMediaKit.fadeOut();
        });
    });
})(jQuery, $c0445db728cdb526$exports);


var $6348892b03b781e3$exports = {};
(function($, root, undefined) {
    $(function() {
        'use strict';
        const filter = $('#performances-filter');
        const results = $('#result');
        const chosenOptions = $('#chosen-options');
        const performancesSearch = $('#performances-search');
        const searchInput = $('#search-input');
        const searchSubmit = $('#search-submit');
        // dropdown options
        let options = filter.find('.options .option');
        // chosen options
        let choices = chosenOptions.find('.choice');
        // parallax
        function createParallax() {
            gsap.to(".parallax-item", {
                scrollTrigger: {
                    scrub: true
                },
                y: (i, target)=>-ScrollTrigger.maxScroll(window) * target.dataset.speed,
                ease: "none"
            });
        }
        createParallax();
        // performance card animations
        function animateCards() {
            let performanceCards = $('.card.performance');
            performanceCards.each(createCardHover);
        }
        animateCards();
        function createCardHover(i, element) {
            let front = $(element).find('.front');
            let back = $(element).find('.back');
            let backTitle = $(back).find('.name');
            var tl = gsap.timeline({
                paused: true,
                reversed: true
            });
            tl.to(front, {
                duration: .2,
                ease: Power4.easeOut,
                autoAlpha: 0
            });
            tl.to(back, {
                duration: .8,
                delay: -0.2,
                ease: Power4.easeOut,
                autoAlpha: 1
            });
            tl.from(backTitle, {
                duration: .6,
                delay: -0.8,
                ease: Power4.easeOut,
                y: '144px'
            });
            $(element).hover(doIt);
            function doIt() {
                tl.reversed() ? tl.play() : tl.reverse().timeScale(-3);
            }
        }
        // add option to chosen options container
        function addOption(option) {
            let termId = option.attr('id');
            let termName = option.data('termName');
            let choice = "<div data-term-id='" + termId + "' class='choice'>" + termName + "</div>";
            chosenOptions.append(choice);
        }
        // remove selected option from dropdown
        function removeOption(termId) {
            // remove active class from dropdown option
            let option = $('#' + termId);
            option.removeClass('active');
            // remove from chosen options
            let choiche = $('.choice[data-term-id="' + termId + '"]');
            choiche.remove();
        }
        // get active options
        function get_active_options(taxonomy) {
            let termIds = []; // for storing active options
            let options = $('#' + taxonomy).find('.options .option');
            // find active elements
            options.each(function() {
                if ($(this).hasClass('active')) {
                    let termId = $(this).attr('id');
                    termIds.push(termId);
                }
            });
            return termIds;
        }
        // get performances -> ajax
        function get_performances() {
            get_active_options();
            // add class to results wrapper
            results.addClass('loading');
            // get values from select fields
            var age = get_active_options('leeftijd');
            var year = get_active_options('leerjaar');
            var location = get_active_options('locatie');
            var price = get_active_options('prijsklasse');
            var discipline = get_active_options('discipline');
            var theme = get_active_options('thema');
            var month = get_active_options('speelperiode');
            var search = searchInput.val();
            var display = $('.view.active').attr('id');
            var data = {
                'action': 'get_performances',
                'age': age,
                'year': year,
                'location': location,
                'price': price,
                'discipline': discipline,
                'theme': theme,
                'month': month,
                'search': search,
                'display': display
            };
            // ajax
            $.ajax({
                url: ajaxurl,
                action: 'get_performances',
                type: 'post',
                dataType: "json",
                data: data,
                success: function(response) {
                    // console.log(response);
                    var posts = response[0].posts;
                    var total = response[0].results;
                    // add scores to results element
                    $(results).html(posts);
                    $(results).removeClass('loading');
                    $('#count').html(total);
                    animateCards();
                    createParallax();
                }
            });
        }
        // managage back button click
        // if (window.performance && window.performance.navigation.type === window.performance.navigation.TYPE_BACK_FORWARD) {
        //
        // 	let selectFields = $('#performances-filter select');
        // 	let selected = false;
        //
        // 	// check if selection is made
        // 	selectFields.each(function(){
        // 		let options = $(this).find('option');
        // 		options.each(function() {
        // 			if(this.selected){
        // 				selected = true; // one ore more select fields have been selected
        // 			}
        // 		});
        // 	});
        //
        // 	// load saved results if selection has been made
        // 	if(selected == true) {
        // 		var res = localStorage.getItem('response');
        // 		successResponse(res);
        // 	}
        //
        // }
        // change url based on selected options
        function update_url() {
            let termIds = []; // for storing active options
            let options = $(filter).find('.options.has-ids .option');
            // find active elements
            options.each(function() {
                if ($(this).hasClass('active')) {
                    let termId = $(this).attr('id');
                    termIds.push(termId);
                }
            });
            // create string of ids
            let ids_string = termIds.join(",");
            // get active date
            let dateOptions = $(filter).find('.options.dates .option');
            let dates = []; // for storing active dates
            // find active elements
            dateOptions.each(function() {
                if ($(this).hasClass('active')) {
                    let date = $(this).attr('id');
                    dates.push(date);
                }
            });
            let dates_string = dates.join(",");
            // update url
            if (ids_string != '' || dates_string != '') {
                let dates;
                if (dates_string != '') dates = "&dates=" + dates_string + "";
                else dates = '';
                let new_url = "/voorstellingen/?ids=" + ids_string + "" + dates;
                window.history.pushState("data", "Title", new_url);
            } else {
                let new_url = "/voorstellingen/";
                window.history.pushState("data", "Title", new_url);
            }
        }
        // get var from url
        var getUrlParameter = function getUrlParameter(sParam) {
            var sPageURL = window.location.search.substring(1), sURLVariables = sPageURL.split('&'), sParameterName, i;
            for(i = 0; i < sURLVariables.length; i++){
                sParameterName = sURLVariables[i].split('=');
                if (sParameterName[0] === sParam) return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
            }
            return false;
        };
        // check selected options based on url
        function check_selected_options() {
            let ids = getUrlParameter('ids');
            if (ids != null && ids != '') {
                // make array from string
                let arrayOfIds = ids.split(',');
                // loop through options
                for(let i = 0; i < arrayOfIds.length; i++){
                    // make dropdown choice active
                    $('#' + arrayOfIds[i]).addClass('active');
                    //
                    let termName = $('#' + arrayOfIds[i]).data('termName');
                    let choice = "<div data-term-id='" + arrayOfIds[i] + "' class='choice'>" + termName + "</div>";
                    chosenOptions.append(choice);
                }
            }
            let dates = getUrlParameter('dates');
            if (dates != null && dates != '') {
                // make array from string
                let arrayOfDates = dates.split(',');
                // loop through options
                for(let i = 0; i < arrayOfDates.length; i++){
                    // make dropdown choice active
                    $('#' + arrayOfDates[i]).addClass('active');
                    //
                    let termName = $('#' + arrayOfDates[i]).data('termName');
                    let choice = "<div data-term-id='" + arrayOfDates[i] + "' class='choice'>" + termName + "</div>";
                    chosenOptions.append(choice);
                }
            }
            get_performances();
        }
        check_selected_options();
        // dropdown option click
        options.click(function() {
            let option = $(this);
            let termId = option.attr('id');
            let termText = option.text();
            let category = $(this).closest('.dropdown').attr('id');
            // remove other selected options if dates
            // if(category === 'speelperiode') {
            // 	let otherOptions = $('#'+category).find('.option').not(option);
            // 	otherOptions.removeClass('active');
            // 	otherOptions.each(function() {
            // 		let otherOptionId = $(this).attr('id');
            // 		removeOption(otherOptionId);
            // 	});
            // }
            $(this).toggleClass('active');
            // add option
            if ($(this).hasClass('active')) addOption(option);
            else removeOption(termId);
            update_url();
            get_performances();
        });
        // remove option when clicked on choice
        $(document).on("click", '.choice', function() {
            let termId = $(this).data('termId');
            removeOption(termId);
            if ($('.page-template-voorstellingen').length) {
                get_performances();
                update_url();
            }
        });
        // make search field active
        searchInput.focus(function() {
            $(performancesSearch).addClass('active');
        });
        // close performances search field
        $('#performances-search-close').click(function() {
            $(performancesSearch).removeClass('active');
            searchInput.val('');
            get_performances();
        });
        $(document).on('keypress', function(e) {
            if (e.which == 13) get_performances();
        });
        // close playlist search field
        $('.performances-search-close').click(function() {
            $(performancesSearch).removeClass('active');
            searchInput.val('');
            updatePlaylist();
        });
        // get performances in search submit click
        searchSubmit.click(function() {
            get_performances();
        });
        // change view / layout
        $('.display .view').click(function() {
            $('.display .view').not(this).removeClass('active');
            $(this).addClass('active');
            get_performances();
        });
        // artiesten zoekfilter
        $(searchInput).on('keyup', function() {
            let searchVal = $(this).val();
            let filterItems = $('.artists .col');
            if (searchVal != '') {
                filterItems.hide();
                $('[data-artist-name*="' + searchVal.toLowerCase() + '"]').show();
            } else filterItems.show();
        });
        // technique zoekfilter
        $('#search-input-technique').on('keyup', function() {
            let searchVal = $(this).val();
            let filterItems = $('#technique .artist');
            if (searchVal != '') {
                filterItems.hide();
                $('[data-performance*="' + searchVal.toLowerCase() + '"]').closest('.artist').show();
                $('[data-artist-name*="' + searchVal.toLowerCase() + '"]').show();
            } else filterItems.fadeIn(200);
        });
        // close search field
        $('#artists-search-close').click(function() {
            $(performancesSearch).removeClass('active');
            searchInput.val('');
            $('.artists .col').fadeIn();
        });
        //
        // playlist filter
        //
        const playlistFilter = $('.playlist-filter');
        let playlistFilterOptions = playlistFilter.find('.options .option');
        let performancesRows = $('#playlist .item');
        // go through selected artist IDs
        function showRowsSelectedArtist() {
            let artistIds = get_active_options('artiest');
            for(let i = 0; i < artistIds.length; ++i)// show the row(s) that have the artist ID
            $('#playlist .item[data-artist-id="' + artistIds[i] + '"]').show().addClass('active');
        }
        // go through selected performance IDs
        function showRowsSelectedPerformances() {
            let performamceIds = get_active_options('voorstelling');
            for(let i = 0; i < performamceIds.length; ++i)// show the row(s) that have the artist ID
            $('#playlist .item[data-performance-id="' + performamceIds[i] + '"]').show().addClass('active');
        }
        // go through selected dates IDs
        function showRowsSelectedDates() {
            let dateIds = get_active_options('datum');
            for(let i = 0; i < dateIds.length; ++i)// show the row(s) that have the artist ID
            $('#playlist .item[data-date-id="' + dateIds[i] + '"]').show().addClass('active');
        }
        // hide empty months
        function hideEmptyMonths() {
            let monthRows = $('#playlist .month-rows');
            $('.month').show();
            monthRows.each(function() {
                let display = false;
                let rows = $(this).find('.row');
                // loop through rows
                rows.each(function() {
                    let row = $(this);
                    if (row.hasClass('active')) {
                        display = true;
                        return false;
                    }
                });
                if (display !== true) $(this).prev('.month').hide();
                // remove background from rows
                $('.row.item').css('background', 'none');
                $('.row.item.active:even').css("background-color", "rgba(255,255,255,.6");
            });
        }
        // add background to odd items
        function addBackground() {
            $('.row.item').css('background', 'none');
            $('.row.item.active:even').css("background-color", "rgba(255,255,255,.6");
        }
        addBackground();
        // show selected artists/performances rows
        function show_selected_items() {
            performancesRows.hide().removeClass('active');
            showRowsSelectedArtist();
            showRowsSelectedPerformances();
            showRowsSelectedDates();
            hideEmptyMonths();
            addBackground();
            createParallax();
        }
        // update playlist
        function updatePlaylist() {
            var choicesLength = $(".choice").length;
            if (choicesLength === 0) {
                performancesRows.css('display', 'flex').addClass('active');
                $('.month').show();
                addBackground();
            } else show_selected_items();
        }
        // show rows of selected items
        playlistFilterOptions.click(function() {
            updatePlaylist();
        });
        // remove option when clicked on choice
        $(document).on("click", '.choice', function() {
            updatePlaylist();
        });
        // Speelijst zoekfilter
        $(searchInput).on('keyup', function() {
            let searchVal = $(this).val();
            let filterItems = $(performancesRows);
            if (searchVal != '') {
                filterItems.removeClass('active').hide();
                $('[data-performance-name*="' + searchVal.toLowerCase() + '"]').addClass('active').css('display', 'flex');
                $('[data-artist-name*="' + searchVal.toLowerCase() + '"]').addClass('active').css('display', 'flex');
                $('[data-location-name*="' + searchVal.toLowerCase() + '"]').addClass('active').css('display', 'flex');
                $('[data-location-city*="' + searchVal.toLowerCase() + '"]').addClass('active').css('display', 'flex');
                hideEmptyMonths();
                addBackground();
            } else updatePlaylist();
        });
        // get id from url
        var getUrlParameter = function getUrlParameter(sParam) {
            var sPageURL = window.location.search.substring(1), sURLVariables = sPageURL.split('&'), sParameterName, i;
            for(i = 0; i < sURLVariables.length; i++){
                sParameterName = sURLVariables[i].split('=');
                if (sParameterName[0] === sParam) return sParameterName[1], decodeURIComponent(sParameterName[1]);
            }
            return false;
        };
        // check if voorstelling is set
        var performanceId = getUrlParameter('voorstelling');
        if (performanceId !== false) {
            // check the box
            $('#' + performanceId).addClass('active');
            // add choice
            let option = $('#' + performanceId);
            addOption(option);
            show_selected_items();
        }
        // check if artiest is set
        var artistId = getUrlParameter('artiest');
        if (artistId !== false) {
            // check the box
            $('#' + artistId).addClass('active');
            // add choice
            let option = $('#' + artistId);
            addOption(option);
            show_selected_items();
        }
    });
})(jQuery, $6348892b03b781e3$exports);



})();
//# sourceMappingURL=index.js.map
